import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { sortByColumn } from './utils/sorters';
import { ExchangeContentControlContentFilteringRuleSettingsFilterByExpression } from '@nirvana/shared/dtos/types/policies/common';

export class GzExchangeContentControlContentFilteringByGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeContentControlContentFilteringRuleSettingsFilterByExpression
> {
  sortByColumnMethod(
    a: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
    b: ExchangeContentControlContentFilteringRuleSettingsFilterByExpression,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }
}
